import React from 'react'
import { PageTitle, Paragraph, ParaTitle, Pagination, CodeSnippet} from "../common";
import './Updates.css';

const Updates_3_42_0 = () => {
  return (
    <div>
      <PageTitle title='3.42.0' />

      <ParaTitle paraTitle='Dashboard Options & Question Set Change' />
      <Paragraph paragraph='2025-06-05' />

      <ParaTitle paraTitle='Added:' />
      <ul>
        <li>
          Classic View Dashboard as an option
          <p>Let users choose between the new dashboard or the previous one (Classic View)</p>
        </li>
        <li>
          Add last Activity Date to User dashboard
          <p>Add an extra column to the User's table where the date of the last activity is listed.</p>
        </li>
      </ul>

      <ParaTitle paraTitle='Changed:' />
      <ul>
        <li>Suicide/Suicide Attempt for HHSCv1 Question Set
          <p>Change the option <CodeSnippet codeSnippet="Suicide/Suicide Attempt" /> to Incident.</p>
        </li>
        <li>RCHI new domain name migration testing
          <p>
            Makes the application more robust and resistant to change.
            It will also future proof the application if it needs to be migrated in future.
            Lastly, we can migrate the application without worrying about bugs or the application crashing.
          </p>
        </li>
      </ul>

      <ParaTitle paraTitle='Removed:' />
      <ul>
        <li>
          Help Desk Ticket - unable to see assigned reviews bug
          <p></p>
        </li>
      </ul>
      <Pagination
        pagination={{
          prev: { name: 'Home', link: '/' },
          next: { name: 'Events Summary', link: '/general/events-summary' }
        }}
      />
    </div>

  )
}

export default Updates_3_42_0;